import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

import { versionTriggerSchema } from "./version";

export const createVersionSchema = z.object({
  title: z.string().min(1).max(100).optional(),
  trigger: versionTriggerSchema.default("manual"),
});

export class CreateVersionDto extends createZodDto(createVersionSchema) {}

// For 15-minute interval auto-save with previous data for diff
export const createAutoVersionSchema = z.object({
  previousData: z.record(z.unknown()), // The last known state for diff comparison
});

export class CreateAutoVersionDto extends createZodDto(createAutoVersionSchema) {}
